<template>
  <div>
    <Header></Header>

    <div class="banner i_mooc">
      <p>
        보기만 하는 강의는 NO!<br />
        이제 보고, 듣고, <span>말하기까지 가능한</span>
      </p>
      <h2>i:MOOC <span class="m_enter2">이러닝과정</span></h2>
    </div>
    <div class="imooc_point">
      <h2><span>i:MOOC 이러닝</span>특장점!</h2>
      <div>
        <div class="thum">
          <img
            src="@/assets/img/i_mooc_phon.png"
            alt="i:MOOC 이러닝 특장점!"
            class="only_pc"
          />
          <img
            src="@/assets/img/m/i_mooc_phon.png"
            alt="i:MOOC 이러닝 특장점!"
            class="only_m"
          />
        </div>
        <ol>
          <li class="step1">
            <span>1</span>
            <h3>우수한 컨텐츠 품질</h3>
            글로벌역량개발연구소의<br />
            컨텐츠 및 영상제작 전문인력을 통한<br />
            100% 자체 제작의 우수한 컨텐츠 생산력
          </li>
          <li class="step2">
            <span>2</span>
            <h3>풍부한 컨텐츠 보유</h3>
            7,000여 편의 외국어, 시사영어뉴스,<br />
            이문화, 지식 큐레이션, 리더십 등<br />
            다양한 컨텐츠 보유
          </li>
          <li class="step3">
            <span>3</span>
            <h3>맞춤형 서비스</h3>
            다년 간의 서비스 운영 노하우를 통해<br />
            학습집단의 교육 니즈에 맞춘<br />
            강좌 큐레이션 및 학습관리 진행
          </li>
        </ol>
      </div>
    </div>

    <div class="imooc_sample">
      <h2>
        <span>
          <img
            src="@/assets/img/sample_title.png"
            alt="썸네일을 클릭하세요~!"
          />
        </span>
        샘플 강의보기
      </h2>
      <div class="clearfix">
        <div class="sample_video">
          <video
            id="video"
            controlslist="nodownload"
            controls="controls"
            autoplay
          >
            <source
              src="https://cdn.carrotenglish.com:11443/imooc/mobile/LC/BS/LC_BS_uwtui9_5155.mp4"
              type="video/mp4"
            />
            <source />
          </video>
        </div>
        <ul class="clearfix">
          <li
            class="pointer"
            @click="
              newPage(
                'https://www.imooc.co.kr/lecture?course_idx=3731&idx=25343'
              )
            "
          >
            <a>
              <div class="thum thum-img1">
                <span class="load"
                  ><img src="@/assets/img/load.png" alt="재생"
                /></span>
              </div>
              <h3>제2외국어</h3>
            </a>
          </li>
          <li
            class="pointer"
            @click="
              newPage(
                'https://reuters.carrotenglish.com/cafe/pop_news_learn_recommend?news_seq=131955'
              )
            "
          >
            <a>
              <div class="thum thum-img2">
                <span class="load"
                  ><img src="@/assets/img/load.png" alt="재생"
                /></span>
              </div>
              <h3>로이터</h3>
            </a>
          </li>
          <li
            class="pointer"
            @click="
              newPage(
                'https://www.imooc.co.kr/lecture?course_idx=3707&idx=25181'
              )
            "
          >
            <a>
              <div class="thum thum-img3">
                <span class="load"
                  ><img src="@/assets/img/load.png" alt="재생"
                /></span>
              </div>
              <h3>i:MOOC</h3>
            </a>
          </li>
          <li
            class="pointer"
            @click="
              newPage(
                'https://www.imooc.co.kr/lecture?course_idx=2509&idx=18534'
              )
            "
          >
            <a>
              <div class="thum thum-img4">
                <span class="load"
                  ><img src="@/assets/img/load.png" alt="재생"
                /></span>
              </div>
              <h3>이문화</h3>
            </a>
          </li>
        </ul>
      </div>
    </div>

    <div class="imooc_learning">
      <span class="check_point_label">HRD Check Point</span>
      <h2>
        <span>22년 노하우 그대로!</span>
        효과성 중심 이러닝
      </h2>
      <div class="check_point">
        <img
          src="@/assets/img/check_point.png"
          alt="효과성 중심 이러닝"
          class="only_pc"
        />
        <img
          src="@/assets/img/m/check_point.png"
          alt="효과성 중심 이러닝"
          class="only_m"
        />
        <ul class="check_point_list">
          <li>
            <img src="@/assets/img/icon_check1.png" alt="" />
            <strong>100% 자체 제작</strong>의<br />믿을 수 있는 컨텐츠
          </li>
          <li>
            <img src="@/assets/img/icon_check2.png" alt="" />
            <strong>현업도 높은</strong> 비지니스<br />중심 컨텐츠 구성
          </li>
          <li>
            <img src="@/assets/img/icon_check3.png" alt="" />
            마이크로러닝의<br /><strong>몰입도 높은</strong> 학습 구성
          </li>
          <li>
            <img src="@/assets/img/icon_check4.png" alt="" />
            지속 제작으로 최신의<br /><strong>신규 컨텐츠 제공</strong>
          </li>
        </ul>
      </div>

      <ul class="check_learning">
        <li>
          <span class="label">학습 포인트 1</span>
          <h3>효과적인 마이크로닝 학습</h3>
          <img src="@/assets/img/learning1.png" alt="" />
        </li>
        <li>
          <span class="label">학습 포인트 2</span>
          <h3>퀴즈를 통한 학습 이해도 점검</h3>
          <img src="@/assets/img/learning2.png" alt="" />
        </li>
        <li>
          <span class="label">학습 포인트 3</span>
          <h3>강의 속 핵심표현 실전 말하기 훈련</h3>
          <img src="@/assets/img/learning3.png" alt="" />
        </li>
      </ul>
    </div>

    <div class="imooc_banner">
      <p class="only_pc">
        기업 전용 플랫폼 운영을 통한<br />
        <strong>컨텐츠 맞춤 구성</strong>에서
        <strong>자사 컨텐츠 탑재 및 서비스까지!</strong><br />
        <span>100% 고객사 맞춤 운영</span>
      </p>
      <p class="only_m">
        기업 전용 플랫폼 운영을 통한<br />
        <strong>컨텐츠 맞춤 구성</strong>에서<br />
        <strong>자사 컨텐츠 탑재 및 서비스까지!</strong><br />
        <span>100% 고객사 맞춤 운영</span>
      </p>
    </div>

    <div class="tech_qa">
      <div class="inner">
        <h2>문의하기</h2>
        <p>
          B2B 교육 및 솔루션에 대한 문의를 남겨주시면 담당자가 확인 후
          <span class="pc_enter">최대한 빠른 시간 내에 연락드리겠습니다.</span>
          <strong
            >(혹시 이미 교육을 받고 계신 학습자이신가요?
            <a
              class="pointer"
              @click="newPage('http://carrotenglish.kr/phone/main_new/contact')"
              >Click!</a
            >)</strong
          >
        </p>

        <div class="qa_table">
          <div>
            <h3>회사명</h3>
            <input type="text" class="qa-input" v-model="inquiryData.company" />
          </div>
          <div>
            <h3>담당자명</h3>
            <input type="text" class="qa-input" v-model="inquiryData.manager" />
          </div>
          <div>
            <h3>연락처</h3>
            <input type="text" class="qa-input" v-model="inquiryData.phone" />
          </div>
          <div>
            <h3>이메일</h3>
            <input type="text" class="qa-input" v-model="inquiryData.email" />
          </div>
          <div>
            <h3>유입경로</h3>
            <ul class="funnel-list">
              <li>
                <input
                  type="radio"
                  name="path"
                  id="path1"
                  value="path1"
                  v-model="selectEnterPath"
                />
                <label for="path1" class="pointer">캐럿 담당자 미팅</label>
              </li>
              <li>
                <input
                  type="radio"
                  name="path"
                  id="path2"
                  value="path2"
                  v-model="selectEnterPath"
                />
                <label for="path2" class="pointer"
                  >캐럿 컨퍼런스 및 설명회 등 모임</label
                >
              </li>
              <li>
                <input
                  type="radio"
                  name="path"
                  id="path3"
                  value="path3"
                  v-model="selectEnterPath"
                />
                <label for="path3" class="pointer"
                  >온라인 홍보 (HR캐스터, 이메일 홍보, 인스타그램, 유튜브,
                  블로그 등)</label
                >
              </li>
              <li>
                <input
                  type="radio"
                  name="path"
                  id="path4"
                  value="path4"
                  v-model="selectEnterPath"
                />
                <label for="path4" class="pointer">인터넷 검색</label>
              </li>
              <li>
                <input
                  type="radio"
                  name="path"
                  id="path5"
                  value="path5"
                  v-model="selectEnterPath"
                />
                <label for="path5" class="pointer"
                  >캐럿글로벌 종합안내서 책자 및 사보 등 자료</label
                >
              </li>
              <li>
                <input
                  type="radio"
                  name="path"
                  id="path6"
                  value="path6"
                  v-model="selectEnterPath"
                />
                <label for="path6" class="pointer"
                  >타사 담당자 및 전임자 등 지인 소개</label
                >
              </li>
              <li class="etc">
                <input
                  type="radio"
                  name="path"
                  id="path7"
                  value="path7"
                  v-model="selectEnterPath"
                />
                <label for="path7" class="pointer">기타</label>
                <input
                  v-show="selectEnterPath === 'path7'"
                  type="text"
                  name="enterPathText"
                  id="enterPathText"
                  class="etc-input"
                  placeholder="직접 입력"
                  v-model="selectEnterPathText"
                />
              </li>
            </ul>
          </div>
          <div class="qa_cont">
            <h3>문의사항</h3>
            <textarea
              class="textarea"
              placeholder="온라인·AI교육과정 문의합니다."
              v-model="inquiryData.contents"
            ></textarea>
          </div>
          <div class="qa_agree">
            <p>
              <input
                type="checkbox"
                id="agree_check"
                v-model="inquiryData.agree"
              />
              <label for="agree_check" class="check_label"
                >개인정보 수집 및 이용에 동의합니다.</label
              >
            </p>
            <button class="pointer" @click="saveInquiry()">확인</button>
          </div>
        </div>
      </div>
    </div>

    <Footer></Footer>
  </div>
</template>

<script>
import Header from "@/components/Solutions/Header.vue";
import Footer from "@/components/Solutions/Footer.vue";
export default {
  components: { Header, Footer },
  data() {
    return {
      inquiryData: {
        category: "INBOUND",
        company: "", //고객사명
        manager: "", //담당자
        phone: "", //연락처
        email: "", //이메일
        contents: "", //내용
        agree: false,
        enterPath: "", //유입경로
        enterPathText: "",
        enterUrl: window.location.href, //사이트주소
      },
      selectEnterPath: "",
      selectEnterPathText: "",
      pathValue: [
        { key: "path1", value: "캐럿 담당자 미팅" },
        { key: "path2", value: "캐럿 컨퍼런스 및 설명회 등 모임" },
        {
          key: "path3",
          value:
            "온라인 홍보 (HR캐스터, 이메일 홍보, 인스타그램, 유튜브, 블로그 등)",
        },
        { key: "path4", value: "인터넷 검색" },
        { key: "path5", value: "캐럿글로벌 종합안내서 책자 및 사보 등 자료" },
        { key: "path6", value: "타사 담당자 및 전임자 등 지인 소개" },
        { key: "path7", value: "기타" },
      ],
    };
  },
  methods: {
    newPage(path) {
      window.open(path, "_blank");
    },
    saveInquiry() {
      let flag = false;
      for (const key in this.inquiryData) {
        if (key === "company" && !this.inquiryData[key]) {
          alert("회사명을 입력해주세요");
          flag = true;
          return;
        } else if (key === "manager" && !this.inquiryData[key]) {
          alert("담당자명을 입력해주세요");
          flag = true;
          return;
        } else if (key === "phone" && !this.inquiryData[key]) {
          alert("연락처를 입력해주세요");
          flag = true;
          return;
        } else if (key === "email" && !this.inquiryData[key]) {
          alert("이메일을 입력해주세요");
          flag = true;
          return;
        } else if (key === "contents" && !this.inquiryData[key]) {
          alert("내용을 입력해주세요");
          flag = true;
          return;
        } else if (key === "agree" && !this.inquiryData[key]) {
          alert("개인정보 수집에 동의해주세요");
          flag = true;
          return;
        }
      }

      if (
        !this.inquiryData["enterPath"] &&
        !this.inquiryData["enterPathText"]
      ) {
        alert("유입경로를 선택 및 기타에 입력해주세요");
        flag = true;
        return false;
      }

      if (!flag) {
        const find = this.pathValue.find(
          (findItem) => findItem["key"] === this.inquiryData["enterPath"]
        );
        const pathText = find ? find["value"] : "";
        this.inquiryData["enterPath"] = pathText;

        this.axios
          .get("/rest/external/addSMP", { params: this.inquiryData })
          .then((res) => {
            if (res.data.err === 0) {
              alert("문의가 완료되었습니다.");
              this.inquiryData = {
                category: "INBOUND",
                company: "", //고객사명
                manager: "", //담당자
                phone: "", //연락처
                email: "", //이메일
                contents: "", //내용
                agree: false,
                enterPath: "",
                enterPathText: "",
                enterUrl: window.location.href, //사이트주소
              };
              this.selectEnterPath = "";
              this.selectEnterPathText = "";
            } else {
              alert(res.data.err_msg);
            }
          })
          .catch((err) => {
            console.error("err : ", err);
            alert("문의하기에 실패하였습니다.");
          });
      }
    },
  },

  watch: {
    selectEnterPath: function (val) {
      if (val === "path7") {
        this.inquiryData.enterPath = "";
      } else {
        this.inquiryData.enterPath = val;
        this.inquiryData.enterPathText = "";
        this.selectEnterPathText = "";
      }
    },

    selectEnterPathText: function (val) {
      this.inquiryData.enterPathText = val;
    },
  },
};
</script>
<style lang="scss" scoped>
.banner.i_mooc {
  height: 780px;
  background-image: url("~@/assets/img/i_mooc_banner.png");
}

.banner.i_mooc p {
  padding-top: 212px;
  font-size: 42px;
  font-weight: 500;
  color: #fff;
  letter-spacing: -1.2px;
  text-shadow: 0px 4px 16px rgba(0, 0, 0, 0.71);
  line-height: 1.479;
}

.banner.i_mooc p span {
  color: #83b5ff;
}

.banner.i_mooc h2 {
  padding-top: 38px;
  font-size: 93px;
  font-weight: bold;
  color: #fff;
  letter-spacing: -1.2px;
}

.imooc_point {
  width: 1200px;
  margin: auto;
  padding: 116px 80px 0 48px;
  box-sizing: border-box;
}

.imooc_point > div {
  position: relative;
}

.imooc_point h2 {
  padding-bottom: 34px;
  text-align: center;
  font-size: 64px;
  font-weight: bold;
  letter-spacing: -1.5px;
  color: #252525;
}

.imooc_point h2 span {
  display: block;
  margin-bottom: -6px;
  font-size: 40px;
  color: #252525;
  font-weight: 500;
  letter-spacing: -1px;
}

.imooc_point ol {
  position: absolute;
  right: 0;
  top: 0;
  padding-top: 18px;
  text-align: left;
  background: url("~@/assets/img/imooc_border.png") 33px 10px no-repeat;
}

.imooc_point li {
  position: relative;
  padding-left: 91px;
  font-size: 18.5px;
  color: #252525;
}

.imooc_point li + li {
  margin-top: 52px;
}

.imooc_point li span {
  position: absolute;
  left: 0;
  top: -5px;
  display: block;
  width: 66px;
  height: 66px;
  border-radius: 50%;
  text-align: center;
  line-height: 64px;
  font-size: 25px;
  font-weight: 500;
  color: #fff;
  letter-spacing: -1px;
  box-sizing: border-box;
}

.imooc_point li.step1 span {
  background-color: #0024ff;
}

.imooc_point li.step2 span {
  background-color: #7d8df2;
}

.imooc_point li.step3 span {
  background-color: #c1c9ff;
}

.imooc_point li h3 {
  padding-bottom: 21px;
  font-size: 35px;
  letter-spacing: -1.5px;
  font-weight: bold;
  color: #252525;
}

.imooc_sample {
  padding: 70px 0 60px;
  background-color: #f0f2fa;
}

.imooc_sample h2 {
  position: relative;
  padding-bottom: 58px;
  font-size: 35px;
  text-align: center;
  font-weight: bold;
  color: #252525;
  letter-spacing: -1px;
}

.imooc_sample h2 span {
  display: block;
  margin: 0 auto -50px;
}

.imooc_sample h2 img {
  margin-left: 35px;
}

.imooc_sample > div {
  width: 1200px;
  margin: auto;
  box-sizing: border-box;
}

.sample_video,
.imooc_sample ul {
  float: left;
}

.sample_video {
  width: 658px;
  height: 370px;
  padding: 4px;
  margin-right: 75px;
  background-color: #fff;
  box-shadow: 0px 7px 43px 0px rgba(0, 36, 255, 0.18);
  box-sizing: border-box;
}

.sample_video #video {
  width: 100%;
  height: 100%;
}

.imooc_sample ul {
  width: calc(100% - 733px);
}

.imooc_sample ul li {
  float: left;
  width: calc(50% - 15px);
  height: 168px;
  margin-right: 30px;
  margin-bottom: 34px;
  box-sizing: border-box;
}

.imooc_sample ul li:nth-child(2n) {
  margin-right: 0;
}

.imooc_sample ul li a {
  display: block;
  width: 100%;
  height: 100%;
  background-color: #fff;
  border-radius: 12px;
  box-shadow: 0px 7px 43px 0px rgba(0, 36, 255, 0.05);
  overflow: hidden;
  box-sizing: border-box;
}

.imooc_sample .thum {
  position: relative;
  width: 100%;
  height: calc(100% - 46px);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  box-sizing: border-box;
}

.imooc_sample .thum .load {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-42%, -25%);
  cursor: pointer;
}

.imooc_sample h3 {
  padding: 0 16px;
  line-height: 44px;
  font-size: 22px;
  font-weight: 500;
  color: #252525;
  background: url("~@/assets/img/arrow_right.png") calc(100% - 16px) 50%
    no-repeat;
}

.thum-img1 {
  background: url("~@/assets/img/thum1.png") no-repeat;
}

.thum-img2 {
  background: url("~@/assets/img/thum2.png") no-repeat;
}

.thum-img3 {
  background: url("~@/assets/img/thum3.png") no-repeat;
}

.thum-img4 {
  background: url("~@/assets/img/thum4.png") no-repeat;
}

.imooc_learning {
  padding-top: 92px;
  text-align: center;
  background: url("~@/assets/img/check_point_bg.png") 0 100% no-repeat;
}

.check_point_label {
  display: inline-block;
  padding: 0 50px;
  height: 88px;
  line-height: 86px;
  font-size: 35px;
  font-weight: bold;
  color: #0024ff;
  letter-spacing: -1px;
  border-radius: 44px;
  border: 1.5px solid #0024ff;
  box-sizing: border-box;
}

.imooc_learning > h2 {
  margin-top: 39px;
  font-size: 64px;
  line-height: 1.1;
  font-weight: bold;
  color: #252525;
  letter-spacing: -1px;
}

.imooc_learning > h2 > span {
  display: block;
  font-size: 40px;
  color: #252525;
  font-weight: 500;
}

.check_point {
  padding-top: 56px;
}

.check_point_list {
  text-align: center;
  margin-top: -5px;
  font-size: 0;
}

.check_point_list li {
  display: inline-block;
  vertical-align: middle;
  width: 277px;
  height: 273px;
  padding-top: 43px;
  border-radius: 23px;
  font-size: 28px;
  font-weight: 500;
  line-height: 1.591;
  color: #252525;
  letter-spacing: -1.2px;
  background-color: #fff;
  box-shadow: 0px 5px 49px 0px rgba(0, 36, 255, 0.07);
  box-sizing: border-box;
}

.check_point_list li + li {
  margin-left: 30px;
}

.check_point_list li img {
  display: block;
  margin: auto;
  padding-bottom: 25px;
}

.check_learning {
  padding-top: 159px;
  font-size: 0;
}

.check_learning li {
  display: inline-block;
  vertical-align: middle;
  width: 370px;
  padding: 37px 24px 52px;
  background-color: #fff;
  border-radius: 23px 23px 0 0;
  box-sizing: border-box;
}

.check_learning li + li {
  margin-left: 45px;
}

.check_learning .label {
  display: inline-block;
  padding: 0 30px;
  height: 46px;
  line-height: 44px;
  margin-bottom: 9px;
  font-size: 22px;
  font-weight: bold;
  color: #0024ff;
  border-radius: 23px;
  letter-spacing: -2px;
  background-color: #e5e9ff;
}

.check_learning h3 {
  padding-bottom: 24px;
  font-size: 22px;
  letter-spacing: -1px;
  color: #252525;
}

.imooc_banner {
  padding: 83px 0 100px;
  background-image: url("~@/assets/img/imooc_bg.png");
  background-position: 50% 0;
  /* background-color: #181818; */
  text-align: center;
}

.imooc_banner p {
  position: relative;
  width: 1200px;
  margin: auto;
  font-size: 35px;
  letter-spacing: -1.2px;
  color: #fff;
  line-height: 1.554;
}

.imooc_banner p::before,
.imooc_banner p::after {
  content: "";
  position: absolute;
  top: 32px;
  width: 35px;
  height: 31px;
}

.imooc_banner p::before {
  left: 154px;
  background: url("~@/assets/img/quotes1.png") 0 0 no-repeat;
}

.imooc_banner p::after {
  right: 154px;
  background: url("~@/assets/img/quotes2.png") 0 0 no-repeat;
}

.imooc_banner p span {
  padding: 0 22px;
  background: url("~@/assets/img/imooc_banner.png") center no-repeat;
}

.tech_qa .inner {
  padding-top: 99px;
  padding-bottom: 103px;
}

.tech_qa p strong a {
  color: #0024ff;
}

.qa_table div.qa_cont {
  position: absolute;
  right: 0;
  top: 3px;
  padding: 0;
  width: 555px;
}

.qa_table div.qa_cont h3 {
  position: static;
  padding-bottom: 15px;
  transform: translateY(0);
}

.textarea {
  width: 100%;
  height: 250px;
  padding: 17px 22px;
  border: 1px solid #252525;
  border-radius: 8px;
  font-size: 20px;
  letter-spacing: -1px;
  box-sizing: border-box;
}

.qa_table div.qa_agree {
  position: absolute;
  right: 0;
  bottom: 0;
  padding: 0;
  width: 555px;
}

/* .qa_agree {
  padding-top: 10px;
  text-align: right;
  font-size: 0;
}

.qa_agree p,
.qa_agree button {
  display: inline-block;
  vertical-align: middle;
} */

.qa_agree button {
  width: 72px;
  height: 40px;
  margin-left: 12px;
  line-height: 38px;
  border-radius: 8px;
  text-align: center;
  font-size: 18px;
  font-weight: 500;
  color: #0024ff;
  border: 1px solid #0024ff;
  box-sizing: border-box;
}

.only_m {
  display: none !important;
}

.funnel-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;

  li {
    display: flex;
    align-items: center;
    gap: 0 5px;

    label {
      font-size: 13px;
      color: #000000;
    }

    input[type="radio"] {
      width: auto;
      margin-bottom: 0;
    }

    input[type="text"] {
      width: auto;
      font-size: 13px;
      color: #ffffff;
      margin-bottom: 0;
    }

    &.etc {
      width: 100%;

      .etc-input {
        color: #000000;
        border-radius: 4px;
        border: 1px solid #252525;
      }
    }
  }
}

@media screen and (max-width: 1200px) {
  .banner.i_mooc {
    height: auto;
    padding-bottom: 99.5px;
    background-image: url("~@/assets/img/m/i_mooc_banner.png");
  }
  .banner.i_mooc p {
    padding-top: 56.5px;
    font-size: 21px;
    line-height: 1.479;
  }

  .banner.i_mooc h2 {
    padding-top: 14px;
    font-size: 46.5px;
  }

  .imooc_point {
    width: 100%;
    padding: 49px 40px 0;
  }

  .imooc_point h2 {
    padding-bottom: 10px;
    font-size: 32px;
  }

  .imooc_point h2 span {
    margin-bottom: -1px;
    font-size: 20px;
  }

  .imooc_point .thum img {
    margin: auto;
    border-width: 0;
    height: auto;
    max-width: 100%;
  }

  .imooc_point ol {
    position: static;
    max-width: 300px;
    margin: auto;
    padding: 29px 0 53px 11px;
    background-position: 34px 57px;
    background-size: auto 100%;
    box-sizing: border-box;
  }

  .imooc_point li {
    position: relative;
    padding-left: 63px;
    font-size: 12.5px;
  }

  .imooc_point li + li {
    margin-top: 38px;
  }

  .imooc_point li span {
    position: absolute;
    left: 0;
    top: -5px;
    width: 45px;
    height: 45px;
    line-height: 43px;
    font-size: 17.5px;
  }

  .imooc_point li h3 {
    padding-bottom: 13px;
    font-size: 24px;
    letter-spacing: -1px;
  }

  .imooc_sample {
    padding: 30px 20px 27.5px;
  }

  .imooc_sample h2 {
    padding-bottom: 26px;
    font-size: 21px;
  }

  .imooc_sample h2 span {
    display: block;
    margin: 0 auto -28px;
  }

  .imooc_sample h2 img {
    margin-left: 6px;
    width: 255px;
  }

  .imooc_sample > div,
  .sample_video {
    width: 100%;
  }

  .sample_video,
  .imooc_sample ul {
    float: none;
  }

  .sample_video {
    width: 100%;
    height: 50.4vw;
    padding: 6px;
    margin-right: 0;
  }

  .imooc_sample ul {
    width: calc(100% - 70px);
    margin: auto;
    padding-top: 25px;
  }

  .imooc_sample ul li {
    width: calc(50% - 9.5px);
    height: auto;
    margin-right: 19px;
    margin-bottom: 19px;
  }

  .imooc_sample ul li a {
    border-radius: 6px;
  }

  .imooc_sample .thum {
    height: 18.667vw;
  }

  .imooc_sample h3 {
    padding: 0 9px;
    /* line-height: 26px; */
    line-height: 1;
    height: 6.934vw;
    font-size: 3.33332vw;
    /* font-size: 12.5px; */
    background: url("~@/assets/img/arrow_right.png") calc(100% - 9px) 50%
      no-repeat;
    background-size: 1vw;
    padding-top: 1.6vw;
    box-sizing: border-box;
  }

  .imooc_sample .thum .load img {
    width: 35px;
  }

  .imooc_learning {
    padding: 46px 20px 0;
    background: url("~@/assets/img/m/check_point_bg.png") 0 700px no-repeat;
    background-size: 100%;
  }

  .check_point_label {
    padding: 0 25px;
    height: 43.5px;
    line-height: 41px;
    font-size: 17.5px;
    border-radius: 22px;
  }

  .imooc_learning > h2 {
    margin-top: 21.5px;
    font-size: 32px;
  }

  .imooc_learning > h2 > span {
    font-size: 20px;
  }

  .check_point {
    padding-top: 35px;
  }

  .check_point img.only_m {
    margin: auto;
    max-width: 100%;
  }

  .check_point_list {
    text-align: center;
    margin-top: -10px;
    font-size: 0;
  }

  .check_point_list li {
    width: calc(50% - 17px);
    height: 156px;
    margin-right: 23px;
    margin-bottom: 23px;
    padding-top: 25px;
    border-radius: 12px;
    font-size: 16px;
    letter-spacing: -1;
  }

  .check_point_list li:nth-child(2n) {
    margin-right: 0;
  }

  .check_point_list li + li {
    margin-left: 0;
  }

  .check_point_list li img {
    width: 37px;
    padding-bottom: 15px;
  }

  .check_learning {
    padding-top: 46px;
  }

  .check_learning li {
    display: block;
    width: 100%;
    padding: 33px 21.5px 29px;
    border-radius: 17.5px;
  }

  .check_learning li + li {
    margin-left: 0;
    margin-top: 38.5px;
  }

  .check_learning h3 {
    padding-bottom: 26px;
    font-size: 16px;
  }

  .check_learning .label {
    padding: 0 28px;
    height: 40px;
    line-height: 38px;
    margin-bottom: 11px;
    font-size: 19px;
    border-radius: 20px;
    letter-spacing: -1px;
  }

  .imooc_banner {
    padding: 44px 0 36.5px;
    background-position: 50% 10%;
  }

  .imooc_banner p {
    width: 100%;
    font-size: 17.5px;
    letter-spacing: -1.2px;
  }

  strong.m_enter2 {
    font-weight: bold;
  }

  .imooc_banner p::before,
  .imooc_banner p::after {
    content: "";
    position: absolute;
    top: 23px;
    width: 17.5px;
    height: 15.5px;
    background-size: 100% !important;
  }

  .imooc_banner p::before {
    left: 40px;
  }

  .imooc_banner p::after {
    right: 40px;
  }

  .imooc_banner p span {
    padding: 0 15px 3px;
    background: url("~@/assets/img/imooc_banner.png") center no-repeat;
    background-size: 100%;
  }

  .tech_qa .inner {
    padding-top: 100px;
  }

  .tech_qa h2 {
    font-size: 24px;
    padding-bottom: 6px;
  }

  .tech_qa > .inner > p {
    padding-bottom: 18px;
    font-size: 15px;
    line-height: 1.3;
  }

  .qa_table div {
    padding: 3px 0 3px 57.5px;
    width: 100%;
  }

  .qa_table div.qa_agree {
    bottom: -45px;
  }

  .qa_agree button {
    width: 42px;
    height: 24px;
    margin-left: 10px;
    line-height: 22px;
    border-radius: 6px;
    font-size: 14px;
    border-width: 1px;
  }

  .imooc.input {
    height: 26px;
    padding: 0 10px;
    border-radius: 4px;
    font-size: 13px;
  }

  .qa_table div.qa_cont {
    position: static !important;
    padding-top: 15px !important;
    width: 100% !important;
  }

  .textarea {
    height: 91px;
    padding: 10px;
    border-radius: 4px;
    font-size: 14px;
  }

  .only_pc {
    display: none;
  }
  .only_m {
    display: block !important;
  }
}

@media screen and (max-width: 350px) {
  .imooc_sample .thum {
    height: 69px;
  }

  .imooc_sample h3 {
    line-height: 26px;
    font-size: 12.5px;
    height: auto;
    padding-top: 0;
    background-size: 3px;
  }
}
</style>
